import React from "react";
import { useTranslation } from "react-i18next";

import { FacilityImageUpload } from "@/components/molecules/FacilityImageUpload";
import { Facility } from "../../../../types/facility.definition";

interface MediaTabProps {
  facility: Facility;
}

export const MediaTab: React.FC<MediaTabProps> = ({ facility }) => {
  const { t } = useTranslation();

  return (
    <div className="space-y-10">
      {/* Thumbnail Section */}
      <div className="space-y-4">
        <div>
          <h3 className="text-lg font-semibold text-neutral-900">
            {t("facilityMedia.thumbnail.title")}
          </h3>
          <p className="text-sm text-neutral-600 mt-1">
            {t("facilityMedia.thumbnail.description")}
          </p>
        </div>
        <FacilityImageUpload
          facilityId={facility.id}
          currentImageUrl={facility.thumbnailPhoto}
          imageType="thumbnail"
          aspectRatio="1:1"
        />
      </div>

      {/* Divider */}
      <div className="border-t border-neutral-200" />

      {/* Banner Section */}
      <div className="space-y-4">
        <div>
          <h3 className="text-lg font-semibold text-neutral-900">
            {t("facilityMedia.banner.title")}
          </h3>
          <p className="text-sm text-neutral-600 mt-1">
            {t("facilityMedia.banner.description")}
          </p>
        </div>
        <FacilityImageUpload
          facilityId={facility.id}
          currentImageUrl={facility.bannerPhoto}
          imageType="banner"
          aspectRatio="3:1"
        />
      </div>

      {/* Recommended sizes note */}
      <div className="p-4 rounded-lg bg-neutral-50 border border-neutral-200">
        <p className="text-xs text-neutral-500">
          {t("facilityMedia.thumbnail.title")}: 400×400px &bull;{" "}
          {t("facilityMedia.banner.title")}: 1200×400px
        </p>
      </div>
    </div>
  );
};
